// Проверка полей пользователя в интерфейсе (FR-030): те же схемы, что на сервере (@kp/contracts),
// и корпоративный домен почты — по списку установки (FR-001в, REC-004). Ошибка — с примером.
import { EmailInputSchema, FullNameInputSchema, fieldMessages, renderError } from '@kp/contracts';

/** Ошибка ФИО или ничего, если значение проходит схему. */
export function fullNameError(value: string): string | undefined {
  return FullNameInputSchema.safeParse(value).success ? undefined : fieldMessages.fullName;
}

/** Домен почты в нижнем регистре: «Morozov@Example.ru» → «example.ru». */
function mailDomain(value: string): string {
  const text = value.trim();
  const at = text.lastIndexOf('@');
  return at > 0 ? text.slice(at + 1).toLowerCase() : '';
}

/**
 * Ошибка почты для входа: формат по схеме, затем домен из списка установки. domains — домены
 * из /api/auth/me; пусто — домен проверяет только сервер.
 */
export function emailError(value: string, domains: readonly string[]): string | undefined {
  const [first, ...rest] = domains;
  if (!EmailInputSchema.safeParse(value).success) {
    return fieldMessages.email.replace('{домен}', first ?? 'example.ru');
  }
  if (first === undefined) return undefined;
  const domain = mailDomain(value);
  const known = domains.map((item) => item.toLowerCase());
  return known.includes(domain)
    ? undefined
    : renderError('REC-004', { domains: [first, ...rest] }).nextStep;
}
